import { useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { flatRoutesAtom } from '../Router/routeAtoms';
import { resolveRouteKey } from '../Router/routes';

/**
 * Canonical key of the route matching the current path.
 *
 * Returns the canonical key rather than the raw `name` — callers compare it
 * against route keys (outcome sections, report configs), and `name` may be a
 * GUID.
 */
const useLocationName = function useLocationName() {
  const location = useLocation();
  const flatRoutes = useAtomValue(flatRoutesAtom);

  const current = flatRoutes.find(
    ({ target }) => `/${target}` === location?.pathname
  );

  return resolveRouteKey(current) ?? current?.name;
};

export default useLocationName;
